export const reasonsList = [
  { show: true, name: 'Funcionário desligado', value: 1 },
  { show: false, name: 'Solicitação do próprio cliente', value: 2 },
  { show: false, name: 'Solicitação do próprio cliente (motivo financeiro)', value: 3 },
  { show: false, name: 'Cliente Inadimplente', value: 4 },
  { show: false, name: 'Outro', value: 5, showReason: true, requiredDescription: true },
  { show: true, name: 'Desistência', value: 6, showReason: true },
  { show: true, name: 'Contrato empresa encerrado', value: 7 },
  { show: true, name: 'Insatisfação', value: 8, showReason: true, requiredDescription: true },
  { show: true, name: 'Pós fidelidade', value: 9, showReason: true },
]
